function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var _n = 0, F = function F() { };
        return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
} var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try {
        a || null == t["return"] || t["return"]();
    }
    finally {
        if (u)
            throw o;
    } } }; }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
} }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { api } from './configs/axiosConfig';
export var UserAPI = /*#__PURE__*/ function () {
    function UserAPI() {
        _classCallCheck(this, UserAPI);
    }
    return _createClass(UserAPI, null, [{
            key: "getUsers",
            value: (
            /**
             * Get all users or a specific user by username
             */
            function () {
                var _getUsers = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(username) {
                    var params, response, _error$response, _t;
                    return _regenerator().w(function (_context) {
                        while (1)
                            switch (_context.p = _context.n) {
                                case 0:
                                    _context.p = 0;
                                    params = username ? {
                                        username: username
                                    } : {};
                                    _context.n = 1;
                                    return api.get('/user', {
                                        params: params
                                    });
                                case 1:
                                    response = _context.v;
                                    return _context.a(2, response.data);
                                case 2:
                                    _context.p = 2;
                                    _t = _context.v;
                                    if (!(((_error$response = _t.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404)) {
                                        _context.n = 3;
                                        break;
                                    }
                                    return _context.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t;
                                case 4:
                                    return _context.a(2);
                            }
                    }, _callee, null, [[0, 2]]);
                }));
                function getUsers(_x) {
                    return _getUsers.apply(this, arguments);
                }
                return getUsers;
            }()
            /**
             * Create a new user
             */
            )
        }, {
            key: "createUser",
            value: (function () {
                var _createUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(userData) {
                    var response, _error$response2, _error$response3, _error$response$data, _t2;
                    return _regenerator().w(function (_context2) {
                        while (1)
                            switch (_context2.p = _context2.n) {
                                case 0:
                                    _context2.p = 0;
                                    _context2.n = 1;
                                    return api.post('/user', userData);
                                case 1:
                                    response = _context2.v;
                                    return _context2.a(2, response.data);
                                case 2:
                                    _context2.p = 2;
                                    _t2 = _context2.v;
                                    if (!(((_error$response2 = _t2.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status) === 400)) {
                                        _context2.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data = _t2.response.data) === null || _error$response$data === void 0 || (_error$response$data = _error$response$data.issue) === null || _error$response$data === void 0 || (_error$response$data = _error$response$data[0]) === null || _error$response$data === void 0 || (_error$response$data = _error$response$data.details) === null || _error$response$data === void 0 ? void 0 : _error$response$data.text) || 'Invalid user data');
                                case 3:
                                    if (!(((_error$response3 = _t2.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.status) === 409)) {
                                        _context2.n = 4;
                                        break;
                                    }
                                    throw new Error('A user with this username already exists');
                                case 4:
                                    throw _t2;
                                case 5:
                                    return _context2.a(2);
                            }
                    }, _callee2, null, [[0, 2]]);
                }));
                function createUser(_x2) {
                    return _createUser.apply(this, arguments);
                }
                return createUser;
            }()
            /**
             * Update an existing user
             */
            )
        }, {
            key: "updateUser",
            value: (function () {
                var _updateUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3(id, userData) {
                    var response, _error$response4, _error$response5, _error$response6, _error$response$data2, _t3;
                    return _regenerator().w(function (_context3) {
                        while (1)
                            switch (_context3.p = _context3.n) {
                                case 0:
                                    _context3.p = 0;
                                    _context3.n = 1;
                                    return api.put("/user/".concat(id), userData);
                                case 1:
                                    response = _context3.v;
                                    return _context3.a(2, response.data);
                                case 2:
                                    _context3.p = 2;
                                    _t3 = _context3.v;
                                    if (!(((_error$response4 = _t3.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.status) === 400)) {
                                        _context3.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data2 = _t3.response.data) === null || _error$response$data2 === void 0 || (_error$response$data2 = _error$response$data2.issue) === null || _error$response$data2 === void 0 || (_error$response$data2 = _error$response$data2[0]) === null || _error$response$data2 === void 0 || (_error$response$data2 = _error$response$data2.details) === null || _error$response$data2 === void 0 ? void 0 : _error$response$data2.text) || 'Invalid user data');
                                case 3:
                                    if (!(((_error$response5 = _t3.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.status) === 404)) {
                                        _context3.n = 4;
                                        break;
                                    }
                                    throw new Error('User not found');
                                case 4:
                                    if (!(((_error$response6 = _t3.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status) === 409)) {
                                        _context3.n = 5;
                                        break;
                                    }
                                    throw new Error('A user with this username already exists');
                                case 5:
                                    throw _t3;
                                case 6:
                                    return _context3.a(2);
                            }
                    }, _callee3, null, [[0, 2]]);
                }));
                function updateUser(_x3, _x4) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
            /**
             * Delete a user by ID or username
             */
            )
        }, {
            key: "deleteUser",
            value: (function () {
                var _deleteUser = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4(id, username) {
                    var params, response, _error$response7, _error$response8, _error$response9, _t4;
                    return _regenerator().w(function (_context4) {
                        while (1)
                            switch (_context4.p = _context4.n) {
                                case 0:
                                    params = {};
                                    if (id)
                                        params.id = id;
                                    if (username)
                                        params.username = username;
                                    _context4.p = 1;
                                    _context4.n = 2;
                                    return api["delete"]('/user', {
                                        params: params
                                    });
                                case 2:
                                    response = _context4.v;
                                    return _context4.a(2, response.data);
                                case 3:
                                    _context4.p = 3;
                                    _t4 = _context4.v;
                                    if (!(((_error$response7 = _t4.response) === null || _error$response7 === void 0 ? void 0 : _error$response7.status) === 400)) {
                                        _context4.n = 4;
                                        break;
                                    }
                                    throw new Error('User ID or username is required');
                                case 4:
                                    if (!(((_error$response8 = _t4.response) === null || _error$response8 === void 0 ? void 0 : _error$response8.status) === 404)) {
                                        _context4.n = 5;
                                        break;
                                    }
                                    throw new Error('User not found');
                                case 5:
                                    if (!(((_error$response9 = _t4.response) === null || _error$response9 === void 0 ? void 0 : _error$response9.status) === 409)) {
                                        _context4.n = 6;
                                        break;
                                    }
                                    throw new Error('Cannot delete user - user has active role assignments');
                                case 6:
                                    throw _t4;
                                case 7:
                                    return _context4.a(2);
                            }
                    }, _callee4, null, [[1, 3]]);
                }));
                function deleteUser(_x5, _x6) {
                    return _deleteUser.apply(this, arguments);
                }
                return deleteUser;
            }()
            /**
             * Assign a role to a user
             */
            )
        }, {
            key: "assignRole",
            value: (function () {
                var _assignRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee5(username, roleData) {
                    var response, _error$response0, _error$response1, _error$response10, _error$response$data3, _t5;
                    return _regenerator().w(function (_context5) {
                        while (1)
                            switch (_context5.p = _context5.n) {
                                case 0:
                                    _context5.p = 0;
                                    _context5.n = 1;
                                    return api.post("/user/role?username=".concat(username), roleData);
                                case 1:
                                    response = _context5.v;
                                    return _context5.a(2, response.data);
                                case 2:
                                    _context5.p = 2;
                                    _t5 = _context5.v;
                                    if (!(((_error$response0 = _t5.response) === null || _error$response0 === void 0 ? void 0 : _error$response0.status) === 400)) {
                                        _context5.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data3 = _t5.response.data) === null || _error$response$data3 === void 0 || (_error$response$data3 = _error$response$data3.issue) === null || _error$response$data3 === void 0 || (_error$response$data3 = _error$response$data3[0]) === null || _error$response$data3 === void 0 || (_error$response$data3 = _error$response$data3.details) === null || _error$response$data3 === void 0 ? void 0 : _error$response$data3.text) || 'Invalid role assignment data');
                                case 3:
                                    if (!(((_error$response1 = _t5.response) === null || _error$response1 === void 0 ? void 0 : _error$response1.status) === 404)) {
                                        _context5.n = 4;
                                        break;
                                    }
                                    throw new Error('User or role not found');
                                case 4:
                                    if (!(((_error$response10 = _t5.response) === null || _error$response10 === void 0 ? void 0 : _error$response10.status) === 409)) {
                                        _context5.n = 5;
                                        break;
                                    }
                                    throw new Error('Role is already assigned to this user');
                                case 5:
                                    throw _t5;
                                case 6:
                                    return _context5.a(2);
                            }
                    }, _callee5, null, [[0, 2]]);
                }));
                function assignRole(_x7, _x8) {
                    return _assignRole.apply(this, arguments);
                }
                return assignRole;
            }()
            /**
             * Update a role assigned to a user
             */
            )
        }, {
            key: "updateUserRole",
            value: (function () {
                var _updateUserRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee6(username, roleData) {
                    var response;
                    return _regenerator().w(function (_context6) {
                        while (1)
                            switch (_context6.n) {
                                case 0:
                                    _context6.n = 1;
                                    return api.put("/user/role?username=".concat(username), roleData);
                                case 1:
                                    response = _context6.v;
                                    return _context6.a(2, response.data);
                            }
                    }, _callee6);
                }));
                function updateUserRole(_x9, _x0) {
                    return _updateUserRole.apply(this, arguments);
                }
                return updateUserRole;
            }()
            /**
             * Remove a role from a user
             */
            )
        }, {
            key: "removeRole",
            value: (function () {
                var _removeRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee7(userId, roleId) {
                    var response;
                    return _regenerator().w(function (_context7) {
                        while (1)
                            switch (_context7.n) {
                                case 0:
                                    _context7.n = 1;
                                    return api["delete"]("/user/role?userId=".concat(userId, "&roleId=").concat(roleId));
                                case 1:
                                    response = _context7.v;
                                    return _context7.a(2, response.data);
                            }
                    }, _callee7);
                }));
                function removeRole(_x1, _x10) {
                    return _removeRole.apply(this, arguments);
                }
                return removeRole;
            }()
            /**
             * Get all roles or roles for a specific user
             */
            )
        }, {
            key: "getRoles",
            value: (function () {
                var _getRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee8(username) {
                    var params, response, _error$response11, _t6;
                    return _regenerator().w(function (_context8) {
                        while (1)
                            switch (_context8.p = _context8.n) {
                                case 0:
                                    _context8.p = 0;
                                    params = username ? {
                                        username: username
                                    } : {
                                        all: true
                                    };
                                    _context8.n = 1;
                                    return api.get('/role', {
                                        params: params
                                    });
                                case 1:
                                    response = _context8.v;
                                    return _context8.a(2, response.data);
                                case 2:
                                    _context8.p = 2;
                                    _t6 = _context8.v;
                                    if (!(((_error$response11 = _t6.response) === null || _error$response11 === void 0 ? void 0 : _error$response11.status) === 404)) {
                                        _context8.n = 3;
                                        break;
                                    }
                                    return _context8.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t6;
                                case 4:
                                    return _context8.a(2);
                            }
                    }, _callee8, null, [[0, 2]]);
                }));
                function getRoles(_x11) {
                    return _getRoles.apply(this, arguments);
                }
                return getRoles;
            }()
            /**
             * Get roles specifically assigned to a user by username
             */
            )
        }, {
            key: "getUserRoles",
            value: (function () {
                var _getUserRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee9(username) {
                    var response, _error$response12, _t7;
                    return _regenerator().w(function (_context9) {
                        while (1)
                            switch (_context9.p = _context9.n) {
                                case 0:
                                    _context9.p = 0;
                                    _context9.n = 1;
                                    return api.get('/user/role', {
                                        params: {
                                            username: username
                                        }
                                    });
                                case 1:
                                    response = _context9.v;
                                    return _context9.a(2, response.data);
                                case 2:
                                    _context9.p = 2;
                                    _t7 = _context9.v;
                                    if (!(((_error$response12 = _t7.response) === null || _error$response12 === void 0 ? void 0 : _error$response12.status) === 404)) {
                                        _context9.n = 3;
                                        break;
                                    }
                                    return _context9.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t7;
                                case 4:
                                    return _context9.a(2);
                            }
                    }, _callee9, null, [[0, 2]]);
                }));
                function getUserRoles(_x12) {
                    return _getUserRoles.apply(this, arguments);
                }
                return getUserRoles;
            }()
            /**
             * Get all users with their roles aggregated - optimized for Team Access page
             * This method returns all users with their assigned roles in a single API call
             * to avoid multiple individual getUserRoles calls
             */
            )
        }, {
            key: "getUsersWithRoles",
            value: (function () {
                var _getUsersWithRoles = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee0() {
                    var response, _error$response13, _t8;
                    return _regenerator().w(function (_context0) {
                        while (1)
                            switch (_context0.p = _context0.n) {
                                case 0:
                                    _context0.p = 0;
                                    _context0.n = 1;
                                    return api.get('/user/with-roles');
                                case 1:
                                    response = _context0.v;
                                    return _context0.a(2, response.data);
                                case 2:
                                    _context0.p = 2;
                                    _t8 = _context0.v;
                                    if (!(((_error$response13 = _t8.response) === null || _error$response13 === void 0 ? void 0 : _error$response13.status) === 404)) {
                                        _context0.n = 3;
                                        break;
                                    }
                                    return _context0.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t8;
                                case 4:
                                    return _context0.a(2);
                            }
                    }, _callee0, null, [[0, 2]]);
                }));
                function getUsersWithRoles() {
                    return _getUsersWithRoles.apply(this, arguments);
                }
                return getUsersWithRoles;
            }()
            /**
             * Get all roles with their policies and assignment counts aggregated - optimized for Role Management page
             * This method returns all roles with their policies and user assignment counts in a single API call
             * to avoid multiple individual getRolePolicies and getRoleAssignmentCount calls
             */
            )
        }, {
            key: "getRolesWithPoliciesAndCounts",
            value: (function () {
                var _getRolesWithPoliciesAndCounts = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee1() {
                    var response, _error$response14, _t9;
                    return _regenerator().w(function (_context1) {
                        while (1)
                            switch (_context1.p = _context1.n) {
                                case 0:
                                    _context1.p = 0;
                                    _context1.n = 1;
                                    return api.get('/role/with-policies-and-counts');
                                case 1:
                                    response = _context1.v;
                                    return _context1.a(2, response.data);
                                case 2:
                                    _context1.p = 2;
                                    _t9 = _context1.v;
                                    if (!(((_error$response14 = _t9.response) === null || _error$response14 === void 0 ? void 0 : _error$response14.status) === 404)) {
                                        _context1.n = 3;
                                        break;
                                    }
                                    return _context1.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t9;
                                case 4:
                                    return _context1.a(2);
                            }
                    }, _callee1, null, [[0, 2]]);
                }));
                function getRolesWithPoliciesAndCounts() {
                    return _getRolesWithPoliciesAndCounts.apply(this, arguments);
                }
                return getRolesWithPoliciesAndCounts;
            }()
            /**
             * Create a new role
             */
            )
        }, {
            key: "createRole",
            value: (function () {
                var _createRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee10(roleData) {
                    var response, _error$response15, _error$response16, _error$response$data4, _t0;
                    return _regenerator().w(function (_context10) {
                        while (1)
                            switch (_context10.p = _context10.n) {
                                case 0:
                                    _context10.p = 0;
                                    _context10.n = 1;
                                    return api.post('/role', roleData);
                                case 1:
                                    response = _context10.v;
                                    return _context10.a(2, response.data);
                                case 2:
                                    _context10.p = 2;
                                    _t0 = _context10.v;
                                    if (!(((_error$response15 = _t0.response) === null || _error$response15 === void 0 ? void 0 : _error$response15.status) === 400)) {
                                        _context10.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data4 = _t0.response.data) === null || _error$response$data4 === void 0 || (_error$response$data4 = _error$response$data4.issue) === null || _error$response$data4 === void 0 || (_error$response$data4 = _error$response$data4[0]) === null || _error$response$data4 === void 0 || (_error$response$data4 = _error$response$data4.details) === null || _error$response$data4 === void 0 ? void 0 : _error$response$data4.text) || 'Invalid role data');
                                case 3:
                                    if (!(((_error$response16 = _t0.response) === null || _error$response16 === void 0 ? void 0 : _error$response16.status) === 409)) {
                                        _context10.n = 4;
                                        break;
                                    }
                                    throw new Error('A role with this name already exists');
                                case 4:
                                    throw _t0;
                                case 5:
                                    return _context10.a(2);
                            }
                    }, _callee10, null, [[0, 2]]);
                }));
                function createRole(_x13) {
                    return _createRole.apply(this, arguments);
                }
                return createRole;
            }()
            /**
             * Update an existing role
             */
            )
        }, {
            key: "updateRole",
            value: (function () {
                var _updateRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee11(id, roleData) {
                    var response, _error$response17, _error$response18, _error$response19, _error$response$data5, _t1;
                    return _regenerator().w(function (_context11) {
                        while (1)
                            switch (_context11.p = _context11.n) {
                                case 0:
                                    _context11.p = 0;
                                    _context11.n = 1;
                                    return api.put("/role/".concat(id), roleData);
                                case 1:
                                    response = _context11.v;
                                    return _context11.a(2, response.data);
                                case 2:
                                    _context11.p = 2;
                                    _t1 = _context11.v;
                                    if (!(((_error$response17 = _t1.response) === null || _error$response17 === void 0 ? void 0 : _error$response17.status) === 400)) {
                                        _context11.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data5 = _t1.response.data) === null || _error$response$data5 === void 0 || (_error$response$data5 = _error$response$data5.issue) === null || _error$response$data5 === void 0 || (_error$response$data5 = _error$response$data5[0]) === null || _error$response$data5 === void 0 || (_error$response$data5 = _error$response$data5.details) === null || _error$response$data5 === void 0 ? void 0 : _error$response$data5.text) || 'Invalid role data');
                                case 3:
                                    if (!(((_error$response18 = _t1.response) === null || _error$response18 === void 0 ? void 0 : _error$response18.status) === 404)) {
                                        _context11.n = 4;
                                        break;
                                    }
                                    throw new Error('Role not found');
                                case 4:
                                    if (!(((_error$response19 = _t1.response) === null || _error$response19 === void 0 ? void 0 : _error$response19.status) === 409)) {
                                        _context11.n = 5;
                                        break;
                                    }
                                    throw new Error('A role with this name already exists');
                                case 5:
                                    throw _t1;
                                case 6:
                                    return _context11.a(2);
                            }
                    }, _callee11, null, [[0, 2]]);
                }));
                function updateRole(_x14, _x15) {
                    return _updateRole.apply(this, arguments);
                }
                return updateRole;
            }()
            /**
             * Delete a role
             */
            )
        }, {
            key: "deleteRole",
            value: (function () {
                var _deleteRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee12(id) {
                    var response, _error$response20, _error$response21, _t10;
                    return _regenerator().w(function (_context12) {
                        while (1)
                            switch (_context12.p = _context12.n) {
                                case 0:
                                    _context12.p = 0;
                                    _context12.n = 1;
                                    return api["delete"]("/role/".concat(id));
                                case 1:
                                    response = _context12.v;
                                    return _context12.a(2, response.data);
                                case 2:
                                    _context12.p = 2;
                                    _t10 = _context12.v;
                                    if (!(((_error$response20 = _t10.response) === null || _error$response20 === void 0 ? void 0 : _error$response20.status) === 404)) {
                                        _context12.n = 3;
                                        break;
                                    }
                                    throw new Error('Role not found');
                                case 3:
                                    if (!(((_error$response21 = _t10.response) === null || _error$response21 === void 0 ? void 0 : _error$response21.status) === 409)) {
                                        _context12.n = 4;
                                        break;
                                    }
                                    throw new Error('Cannot delete role - it is currently assigned to users');
                                case 4:
                                    throw _t10;
                                case 5:
                                    return _context12.a(2);
                            }
                    }, _callee12, null, [[0, 2]]);
                }));
                function deleteRole(_x16) {
                    return _deleteRole.apply(this, arguments);
                }
                return deleteRole;
            }()
            /**
             * Get all policies or policies for a specific user
             */
            )
        }, {
            key: "getPolicies",
            value: (function () {
                var _getPolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee13(username) {
                    var params, response, _error$response22, _t11;
                    return _regenerator().w(function (_context13) {
                        while (1)
                            switch (_context13.p = _context13.n) {
                                case 0:
                                    _context13.p = 0;
                                    params = username ? {
                                        username: username
                                    } : {
                                        all: true
                                    };
                                    _context13.n = 1;
                                    return api.get('/policy', {
                                        params: params
                                    });
                                case 1:
                                    response = _context13.v;
                                    return _context13.a(2, response.data);
                                case 2:
                                    _context13.p = 2;
                                    _t11 = _context13.v;
                                    if (!(((_error$response22 = _t11.response) === null || _error$response22 === void 0 ? void 0 : _error$response22.status) === 404)) {
                                        _context13.n = 3;
                                        break;
                                    }
                                    return _context13.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t11;
                                case 4:
                                    return _context13.a(2);
                            }
                    }, _callee13, null, [[0, 2]]);
                }));
                function getPolicies(_x17) {
                    return _getPolicies.apply(this, arguments);
                }
                return getPolicies;
            }()
            /**
             * Create a new policy
             */
            )
        }, {
            key: "createPolicy",
            value: (function () {
                var _createPolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee14(policyData) {
                    var response, _error$response23, _error$response24, _error$response$data6, _t12;
                    return _regenerator().w(function (_context14) {
                        while (1)
                            switch (_context14.p = _context14.n) {
                                case 0:
                                    _context14.p = 0;
                                    _context14.n = 1;
                                    return api.post('/policy', policyData);
                                case 1:
                                    response = _context14.v;
                                    return _context14.a(2, response.data);
                                case 2:
                                    _context14.p = 2;
                                    _t12 = _context14.v;
                                    if (!(((_error$response23 = _t12.response) === null || _error$response23 === void 0 ? void 0 : _error$response23.status) === 400)) {
                                        _context14.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data6 = _t12.response.data) === null || _error$response$data6 === void 0 || (_error$response$data6 = _error$response$data6.issue) === null || _error$response$data6 === void 0 || (_error$response$data6 = _error$response$data6[0]) === null || _error$response$data6 === void 0 || (_error$response$data6 = _error$response$data6.details) === null || _error$response$data6 === void 0 ? void 0 : _error$response$data6.text) || 'Invalid policy data');
                                case 3:
                                    if (!(((_error$response24 = _t12.response) === null || _error$response24 === void 0 ? void 0 : _error$response24.status) === 409)) {
                                        _context14.n = 4;
                                        break;
                                    }
                                    throw new Error('A policy with this name already exists');
                                case 4:
                                    throw _t12;
                                case 5:
                                    return _context14.a(2);
                            }
                    }, _callee14, null, [[0, 2]]);
                }));
                function createPolicy(_x18) {
                    return _createPolicy.apply(this, arguments);
                }
                return createPolicy;
            }()
            /**
             * Update an existing policy
             */
            )
        }, {
            key: "updatePolicy",
            value: (function () {
                var _updatePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee15(id, policyData) {
                    var response, _error$response25, _error$response26, _error$response27, _error$response$data7, _t13;
                    return _regenerator().w(function (_context15) {
                        while (1)
                            switch (_context15.p = _context15.n) {
                                case 0:
                                    _context15.p = 0;
                                    _context15.n = 1;
                                    return api.put("/policy/".concat(id), policyData);
                                case 1:
                                    response = _context15.v;
                                    return _context15.a(2, response.data);
                                case 2:
                                    _context15.p = 2;
                                    _t13 = _context15.v;
                                    if (!(((_error$response25 = _t13.response) === null || _error$response25 === void 0 ? void 0 : _error$response25.status) === 400)) {
                                        _context15.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data7 = _t13.response.data) === null || _error$response$data7 === void 0 || (_error$response$data7 = _error$response$data7.issue) === null || _error$response$data7 === void 0 || (_error$response$data7 = _error$response$data7[0]) === null || _error$response$data7 === void 0 || (_error$response$data7 = _error$response$data7.details) === null || _error$response$data7 === void 0 ? void 0 : _error$response$data7.text) || 'Invalid policy data');
                                case 3:
                                    if (!(((_error$response26 = _t13.response) === null || _error$response26 === void 0 ? void 0 : _error$response26.status) === 404)) {
                                        _context15.n = 4;
                                        break;
                                    }
                                    throw new Error('Policy not found');
                                case 4:
                                    if (!(((_error$response27 = _t13.response) === null || _error$response27 === void 0 ? void 0 : _error$response27.status) === 409)) {
                                        _context15.n = 5;
                                        break;
                                    }
                                    throw new Error('A policy with this name already exists');
                                case 5:
                                    throw _t13;
                                case 6:
                                    return _context15.a(2);
                            }
                    }, _callee15, null, [[0, 2]]);
                }));
                function updatePolicy(_x19, _x20) {
                    return _updatePolicy.apply(this, arguments);
                }
                return updatePolicy;
            }()
            /**
             * Delete a policy
             */
            )
        }, {
            key: "deletePolicy",
            value: (function () {
                var _deletePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee16(id) {
                    var response, _error$response28, _error$response29, _t14;
                    return _regenerator().w(function (_context16) {
                        while (1)
                            switch (_context16.p = _context16.n) {
                                case 0:
                                    _context16.p = 0;
                                    _context16.n = 1;
                                    return api["delete"]("/policy/".concat(id));
                                case 1:
                                    response = _context16.v;
                                    return _context16.a(2, response.data);
                                case 2:
                                    _context16.p = 2;
                                    _t14 = _context16.v;
                                    if (!(((_error$response28 = _t14.response) === null || _error$response28 === void 0 ? void 0 : _error$response28.status) === 404)) {
                                        _context16.n = 3;
                                        break;
                                    }
                                    throw new Error('Policy not found');
                                case 3:
                                    if (!(((_error$response29 = _t14.response) === null || _error$response29 === void 0 ? void 0 : _error$response29.status) === 409)) {
                                        _context16.n = 4;
                                        break;
                                    }
                                    throw new Error('Cannot delete policy - it is currently assigned to roles');
                                case 4:
                                    throw _t14;
                                case 5:
                                    return _context16.a(2);
                            }
                    }, _callee16, null, [[0, 2]]);
                }));
                function deletePolicy(_x21) {
                    return _deletePolicy.apply(this, arguments);
                }
                return deletePolicy;
            }()
            /**
             * Get policies assigned to a specific role
             */
            )
        }, {
            key: "getRolePolicies",
            value: (function () {
                var _getRolePolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee17(roleId) {
                    var response, _error$response30, _t15;
                    return _regenerator().w(function (_context17) {
                        while (1)
                            switch (_context17.p = _context17.n) {
                                case 0:
                                    _context17.p = 0;
                                    _context17.n = 1;
                                    return api.get("/rolepolicy/".concat(roleId, "/policy"));
                                case 1:
                                    response = _context17.v;
                                    return _context17.a(2, response.data);
                                case 2:
                                    _context17.p = 2;
                                    _t15 = _context17.v;
                                    if (!(((_error$response30 = _t15.response) === null || _error$response30 === void 0 ? void 0 : _error$response30.status) === 404)) {
                                        _context17.n = 3;
                                        break;
                                    }
                                    return _context17.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t15;
                                case 4:
                                    return _context17.a(2);
                            }
                    }, _callee17, null, [[0, 2]]);
                }));
                function getRolePolicies(_x22) {
                    return _getRolePolicies.apply(this, arguments);
                }
                return getRolePolicies;
            }()
            /**
             * Get rolepolicy records for a specific policy (to check which roles use it)
             */
            )
        }, {
            key: "getPolicyRoleRecords",
            value: (function () {
                var _getPolicyRoleRecords = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee18(policyId) {
                    var response, _error$response31, _t16;
                    return _regenerator().w(function (_context18) {
                        while (1)
                            switch (_context18.p = _context18.n) {
                                case 0:
                                    _context18.p = 0;
                                    _context18.n = 1;
                                    return api.get("/rolepolicy/policy/".concat(policyId, "/records"));
                                case 1:
                                    response = _context18.v;
                                    return _context18.a(2, response.data.resource || []);
                                case 2:
                                    _context18.p = 2;
                                    _t16 = _context18.v;
                                    if (!(((_error$response31 = _t16.response) === null || _error$response31 === void 0 ? void 0 : _error$response31.status) === 404)) {
                                        _context18.n = 3;
                                        break;
                                    }
                                    return _context18.a(2, []);
                                case 3:
                                    console.error('Failed to get policy role records:', _t16);
                                    return _context18.a(2, []);
                            }
                    }, _callee18, null, [[0, 2]]);
                }));
                function getPolicyRoleRecords(_x23) {
                    return _getPolicyRoleRecords.apply(this, arguments);
                }
                return getPolicyRoleRecords;
            }()
            /**
             * Delete a specific rolepolicy by its ID
             */
            )
        }, {
            key: "deleteRolePolicyById",
            value: (function () {
                var _deleteRolePolicyById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee19(rolePolicyId) {
                    var _error$response32, _t17;
                    return _regenerator().w(function (_context19) {
                        while (1)
                            switch (_context19.p = _context19.n) {
                                case 0:
                                    _context19.p = 0;
                                    _context19.n = 1;
                                    return api["delete"]("/rolepolicy/".concat(rolePolicyId));
                                case 1:
                                    _context19.n = 4;
                                    break;
                                case 2:
                                    _context19.p = 2;
                                    _t17 = _context19.v;
                                    if (!(((_error$response32 = _t17.response) === null || _error$response32 === void 0 ? void 0 : _error$response32.status) === 404)) {
                                        _context19.n = 3;
                                        break;
                                    }
                                    console.warn("Rolepolicy ".concat(rolePolicyId, " not found, may have been already deleted"));
                                    return _context19.a(2);
                                case 3:
                                    throw _t17;
                                case 4:
                                    return _context19.a(2);
                            }
                    }, _callee19, null, [[0, 2]]);
                }));
                function deleteRolePolicyById(_x24) {
                    return _deleteRolePolicyById.apply(this, arguments);
                }
                return deleteRolePolicyById;
            }()
            /**
             * Get the number of users assigned to a role from principalrole table
             */
            )
        }, {
            key: "getRoleAssignmentCount",
            value: (function () {
                var _getRoleAssignmentCount = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee20(roleId) {
                    var response, _error$response33, _error$response34, userRolesResponse, userRoles, count, _t18, _t19;
                    return _regenerator().w(function (_context20) {
                        while (1)
                            switch (_context20.p = _context20.n) {
                                case 0:
                                    _context20.p = 0;
                                    _context20.n = 1;
                                    return api.get("/role/".concat(roleId, "/assignment/count"));
                                case 1:
                                    response = _context20.v;
                                    return _context20.a(2, response.data.count || 0);
                                case 2:
                                    _context20.p = 2;
                                    _t18 = _context20.v;
                                    if (!(((_error$response33 = _t18.response) === null || _error$response33 === void 0 ? void 0 : _error$response33.status) === 404 || ((_error$response34 = _t18.response) === null || _error$response34 === void 0 ? void 0 : _error$response34.status) === 500)) {
                                        _context20.n = 6;
                                        break;
                                    }
                                    console.warn("Failed to get assignment count for role ".concat(roleId, ", using fallback method"));
                                    // Fallback: try to get user roles and count matching ones
                                    _context20.p = 3;
                                    _context20.n = 4;
                                    return api.get('/user/role', {
                                        params: {
                                            getAll: true
                                        }
                                    });
                                case 4:
                                    userRolesResponse = _context20.v;
                                    userRoles = userRolesResponse.data.resource || [];
                                    count = userRoles.filter(function (userRole) {
                                        var _userRole$roles;
                                        return (_userRole$roles = userRole.roles) === null || _userRole$roles === void 0 ? void 0 : _userRole$roles.some(function (role) {
                                            return role.role_id === roleId;
                                        });
                                    }).length;
                                    return _context20.a(2, count);
                                case 5:
                                    _context20.p = 5;
                                    _t19 = _context20.v;
                                    console.warn("Fallback method also failed for role ".concat(roleId, ":"), _t19);
                                    return _context20.a(2, 0);
                                case 6:
                                    console.warn("Failed to get assignment count for role ".concat(roleId, ":"), _t18);
                                    return _context20.a(2, 0);
                            }
                    }, _callee20, null, [[3, 5], [0, 2]]);
                }));
                function getRoleAssignmentCount(_x25) {
                    return _getRoleAssignmentCount.apply(this, arguments);
                }
                return getRoleAssignmentCount;
            }()
            /**
             * Create role-policy associations (assign policies to a role)
             */
            )
        }, {
            key: "createRolePolicy",
            value: (function () {
                var _createRolePolicy = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee21(requestData) {
                    var response, _error$response35, _error$response36, _error$response37, _error$response$data8, _t20;
                    return _regenerator().w(function (_context21) {
                        while (1)
                            switch (_context21.p = _context21.n) {
                                case 0:
                                    _context21.p = 0;
                                    _context21.n = 1;
                                    return api.post('/rolepolicy', requestData);
                                case 1:
                                    response = _context21.v;
                                    return _context21.a(2, response.data);
                                case 2:
                                    _context21.p = 2;
                                    _t20 = _context21.v;
                                    if (!(((_error$response35 = _t20.response) === null || _error$response35 === void 0 ? void 0 : _error$response35.status) === 400)) {
                                        _context21.n = 3;
                                        break;
                                    }
                                    throw new Error(((_error$response$data8 = _t20.response.data) === null || _error$response$data8 === void 0 || (_error$response$data8 = _error$response$data8.issue) === null || _error$response$data8 === void 0 || (_error$response$data8 = _error$response$data8[0]) === null || _error$response$data8 === void 0 || (_error$response$data8 = _error$response$data8.details) === null || _error$response$data8 === void 0 ? void 0 : _error$response$data8.text) || 'Invalid request data');
                                case 3:
                                    if (!(((_error$response36 = _t20.response) === null || _error$response36 === void 0 ? void 0 : _error$response36.status) === 404)) {
                                        _context21.n = 4;
                                        break;
                                    }
                                    throw new Error('Role or policy not found');
                                case 4:
                                    if (!(((_error$response37 = _t20.response) === null || _error$response37 === void 0 ? void 0 : _error$response37.status) === 409)) {
                                        _context21.n = 5;
                                        break;
                                    }
                                    throw new Error('Policy is already assigned to this role');
                                case 5:
                                    throw _t20;
                                case 6:
                                    return _context21.a(2);
                            }
                    }, _callee21, null, [[0, 2]]);
                }));
                function createRolePolicy(_x26) {
                    return _createRolePolicy.apply(this, arguments);
                }
                return createRolePolicy;
            }()
            /**
             * Assign a policy to a role (legacy method - kept for backward compatibility)
             */
            )
        }, {
            key: "assignPolicyToRole",
            value: (function () {
                var _assignPolicyToRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee22(roleId, policyId) {
                    var response;
                    return _regenerator().w(function (_context22) {
                        while (1)
                            switch (_context22.n) {
                                case 0:
                                    _context22.n = 1;
                                    return api.post("/role/".concat(roleId, "/policy/").concat(policyId));
                                case 1:
                                    response = _context22.v;
                                    return _context22.a(2, response.data);
                            }
                    }, _callee22);
                }));
                function assignPolicyToRole(_x27, _x28) {
                    return _assignPolicyToRole.apply(this, arguments);
                }
                return assignPolicyToRole;
            }()
            /**
             * Remove a policy from a role (legacy method - kept for backward compatibility)
             */
            )
        }, {
            key: "removePolicyFromRole",
            value: (function () {
                var _removePolicyFromRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee23(roleId, policyId) {
                    var response;
                    return _regenerator().w(function (_context23) {
                        while (1)
                            switch (_context23.n) {
                                case 0:
                                    _context23.n = 1;
                                    return api["delete"]("/role/".concat(roleId, "/policy/").concat(policyId));
                                case 1:
                                    response = _context23.v;
                                    return _context23.a(2, response.data);
                            }
                    }, _callee23);
                }));
                function removePolicyFromRole(_x29, _x30) {
                    return _removePolicyFromRole.apply(this, arguments);
                }
                return removePolicyFromRole;
            }()
            /**
             * Delete all role-policy mappings for a specific role
             */
            )
        }, {
            key: "deleteAllRolePolicies",
            value: (function () {
                var _deleteAllRolePolicies = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee24(roleId) {
                    var rolePoliciesResponse, rolePolicies, _iterator, _step, policy, _t21, _t22, _t23;
                    return _regenerator().w(function (_context24) {
                        while (1)
                            switch (_context24.p = _context24.n) {
                                case 0:
                                    _context24.p = 0;
                                    _context24.n = 1;
                                    return this.getRolePolicies(roleId);
                                case 1:
                                    rolePoliciesResponse = _context24.v;
                                    rolePolicies = rolePoliciesResponse.resource; // Delete each rolepolicy record using the proper /rolepolicy/:rolepolicy_id endpoint
                                    _iterator = _createForOfIteratorHelper(rolePolicies);
                                    _context24.p = 2;
                                    _iterator.s();
                                case 3:
                                    if ((_step = _iterator.n()).done) {
                                        _context24.n = 8;
                                        break;
                                    }
                                    policy = _step.value;
                                    _context24.p = 4;
                                    _context24.n = 5;
                                    return this.deleteRolePolicyById(policy.rolepolicy_id);
                                case 5:
                                    _context24.n = 7;
                                    break;
                                case 6:
                                    _context24.p = 6;
                                    _t21 = _context24.v;
                                    console.warn("Failed to delete rolepolicy ".concat(policy.rolepolicy_id, ":"), _t21);
                                // Continue with other deletions even if one fails
                                case 7:
                                    _context24.n = 3;
                                    break;
                                case 8:
                                    _context24.n = 10;
                                    break;
                                case 9:
                                    _context24.p = 9;
                                    _t22 = _context24.v;
                                    _iterator.e(_t22);
                                case 10:
                                    _context24.p = 10;
                                    _iterator.f();
                                    return _context24.f(10);
                                case 11:
                                    _context24.n = 13;
                                    break;
                                case 12:
                                    _context24.p = 12;
                                    _t23 = _context24.v;
                                    console.warn('Failed to delete role policies:', _t23);
                                // Don't throw here as role deletion should still proceed
                                case 13:
                                    return _context24.a(2);
                            }
                    }, _callee24, this, [[4, 6], [2, 9, 10, 11], [0, 12]]);
                }));
                function deleteAllRolePolicies(_x31) {
                    return _deleteAllRolePolicies.apply(this, arguments);
                }
                return deleteAllRolePolicies;
            }()
            /**
             * Remove specific policies from a role using the proper rolepolicy deletion API
             */
            )
        }, {
            key: "removeSpecificPoliciesFromRole",
            value: (function () {
                var _removeSpecificPoliciesFromRole = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee25(roleId, policyIds) {
                    var rolePoliciesResponse, rolePolicies, rolePolicyIdsToDelete, _iterator2, _step2, rolePolicyId, _t24, _t25, _t26;
                    return _regenerator().w(function (_context25) {
                        while (1)
                            switch (_context25.p = _context25.n) {
                                case 0:
                                    _context25.p = 0;
                                    _context25.n = 1;
                                    return this.getRolePolicies(roleId);
                                case 1:
                                    rolePoliciesResponse = _context25.v;
                                    rolePolicies = rolePoliciesResponse.resource; // Find the rolepolicy IDs for the policies we want to remove
                                    rolePolicyIdsToDelete = rolePolicies.filter(function (policy) {
                                        return policyIds.includes(Number(policy.id));
                                    }).map(function (policy) {
                                        return policy.rolepolicy_id;
                                    }); // Delete each rolepolicy record using the proper /rolepolicy/:rolepolicy_id endpoint
                                    _iterator2 = _createForOfIteratorHelper(rolePolicyIdsToDelete);
                                    _context25.p = 2;
                                    _iterator2.s();
                                case 3:
                                    if ((_step2 = _iterator2.n()).done) {
                                        _context25.n = 8;
                                        break;
                                    }
                                    rolePolicyId = _step2.value;
                                    _context25.p = 4;
                                    _context25.n = 5;
                                    return this.deleteRolePolicyById(rolePolicyId);
                                case 5:
                                    _context25.n = 7;
                                    break;
                                case 6:
                                    _context25.p = 6;
                                    _t24 = _context25.v;
                                    console.warn("Failed to delete rolepolicy ".concat(rolePolicyId, ":"), _t24);
                                // Continue with other deletions even if one fails
                                case 7:
                                    _context25.n = 3;
                                    break;
                                case 8:
                                    _context25.n = 10;
                                    break;
                                case 9:
                                    _context25.p = 9;
                                    _t25 = _context25.v;
                                    _iterator2.e(_t25);
                                case 10:
                                    _context25.p = 10;
                                    _iterator2.f();
                                    return _context25.f(10);
                                case 11:
                                    _context25.n = 13;
                                    break;
                                case 12:
                                    _context25.p = 12;
                                    _t26 = _context25.v;
                                    console.error('Failed to remove specific policies from role:', _t26);
                                    throw _t26;
                                case 13:
                                    return _context25.a(2);
                            }
                    }, _callee25, this, [[4, 6], [2, 9, 10, 11], [0, 12]]);
                }));
                function removeSpecificPoliciesFromRole(_x32, _x33) {
                    return _removeSpecificPoliciesFromRole.apply(this, arguments);
                }
                return removeSpecificPoliciesFromRole;
            }()
            /**
             * Get all applications
             */
            )
        }, {
            key: "getApplications",
            value: (function () {
                var _getApplications = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee26(orgId) {
                    var params, response, _error$response38, _t27;
                    return _regenerator().w(function (_context26) {
                        while (1)
                            switch (_context26.p = _context26.n) {
                                case 0:
                                    _context26.p = 0;
                                    params = orgId ? {
                                        orgId: orgId
                                    } : {};
                                    _context26.n = 1;
                                    return api.get('/application', {
                                        params: params
                                    });
                                case 1:
                                    response = _context26.v;
                                    return _context26.a(2, response.data);
                                case 2:
                                    _context26.p = 2;
                                    _t27 = _context26.v;
                                    if (!(((_error$response38 = _t27.response) === null || _error$response38 === void 0 ? void 0 : _error$response38.status) === 404)) {
                                        _context26.n = 3;
                                        break;
                                    }
                                    return _context26.a(2, {
                                        resourceType: 'Bundle',
                                        total: 0,
                                        resource: []
                                    });
                                case 3:
                                    throw _t27;
                                case 4:
                                    return _context26.a(2);
                            }
                    }, _callee26, null, [[0, 2]]);
                }));
                function getApplications(_x34) {
                    return _getApplications.apply(this, arguments);
                }
                return getApplications;
            }()
            /**
             * Get application by ID
             */
            )
        }, {
            key: "getApplicationById",
            value: (function () {
                var _getApplicationById = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee27(applicationId) {
                    var response, _error$response39, _t28;
                    return _regenerator().w(function (_context27) {
                        while (1)
                            switch (_context27.p = _context27.n) {
                                case 0:
                                    _context27.p = 0;
                                    _context27.n = 1;
                                    return api.get("/application/".concat(applicationId));
                                case 1:
                                    response = _context27.v;
                                    return _context27.a(2, response.data);
                                case 2:
                                    _context27.p = 2;
                                    _t28 = _context27.v;
                                    if (!(((_error$response39 = _t28.response) === null || _error$response39 === void 0 ? void 0 : _error$response39.status) === 404)) {
                                        _context27.n = 3;
                                        break;
                                    }
                                    throw new Error('Application not found');
                                case 3:
                                    throw _t28;
                                case 4:
                                    return _context27.a(2);
                            }
                    }, _callee27, null, [[0, 2]]);
                }));
                function getApplicationById(_x35) {
                    return _getApplicationById.apply(this, arguments);
                }
                return getApplicationById;
            }()
            /**
             * Validate email address using UserLookUp API via backend
             */
            )
        }, {
            key: "validateEmail",
            value: (function () {
                var _validateEmail = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee28(email) {
                    var response, data, _error$response40, _error$response41, _error$response$data9, emailRegex, namePart, formattedName, _t29;
                    return _regenerator().w(function (_context28) {
                        while (1)
                            switch (_context28.p = _context28.n) {
                                case 0:
                                    _context28.p = 0;
                                    _context28.n = 1;
                                    return api.get('/user/userlookup', {
                                        params: {
                                            email: email
                                        },
                                        // Add a custom header to indicate this should not trigger error modals
                                        headers: {
                                            'X-Silent-Error': 'true'
                                        }
                                    });
                                case 1:
                                    response = _context28.v;
                                    // The backend now returns a structured response with resourceType
                                    data = response.data;
                                    return _context28.a(2, {
                                        isValid: data.isValid,
                                        userInfo: data.userInfo,
                                        error: data.error
                                    });
                                case 2:
                                    _context28.p = 2;
                                    _t29 = _context28.v;
                                    console.error('Error validating email address:', _t29);
                                    // Silently handle all API errors and provide fallback validation
                                    // Don't trigger error modals for email validation failures
                                    // Handle specific HTTP error codes
                                    if (!(((_error$response40 = _t29.response) === null || _error$response40 === void 0 ? void 0 : _error$response40.status) === 400)) {
                                        _context28.n = 3;
                                        break;
                                    }
                                    return _context28.a(2, {
                                        isValid: false,
                                        error: ((_error$response$data9 = _t29.response.data) === null || _error$response$data9 === void 0 || (_error$response$data9 = _error$response$data9.errors) === null || _error$response$data9 === void 0 ? void 0 : _error$response$data9.description) || 'Invalid email format'
                                    });
                                case 3:
                                    if (((_error$response41 = _t29.response) === null || _error$response41 === void 0 ? void 0 : _error$response41.status) === 500) {
                                        // For 500 errors, use fallback validation instead of showing error
                                        console.warn('Server error during email validation, using fallback');
                                    }
                                    // Fallback to client-side validation for any error
                                    emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    if (emailRegex.test(email)) {
                                        _context28.n = 4;
                                        break;
                                    }
                                    return _context28.a(2, {
                                        isValid: false,
                                        error: 'Invalid email format'
                                    });
                                case 4:
                                    // Extract name from email for user info as fallback
                                    namePart = email.split('@')[0];
                                    formattedName = namePart.split('.').map(function (part) {
                                        return part.charAt(0).toUpperCase() + part.slice(1);
                                    }).join(' ');
                                    return _context28.a(2, {
                                        isValid: true,
                                        userInfo: {
                                            name: formattedName,
                                            email: email,
                                            initials: formattedName.split(' ').map(function (n) {
                                                return n.charAt(0);
                                            }).join('')
                                        }
                                    });
                            }
                    }, _callee28, null, [[0, 2]]);
                }));
                function validateEmail(_x36) {
                    return _validateEmail.apply(this, arguments);
                }
                return validateEmail;
            }())
        }]);
}();
